import { render, staticRenderFns } from "./childComponents.vue?vue&type=template&id=0abc0b62"
import script from "./childComponents.vue?vue&type=script&lang=js"
export * from "./childComponents.vue?vue&type=script&lang=js"
import style0 from "./childComponents.vue?vue&type=style&index=0&id=0abc0b62&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports